import {uuid} from 'vue-uuid'
export default {
	data() {
		return {
			pagination: {
				pageSizes: [10, 20, 50, 100],
				size: 10,
				current: 1,
				total: -1
			},
			messageKey: null,
			msgHandlers: {}
		}
	},
	created() {
		const {messageKey} = this.$route.query
		this.messageKey = !!messageKey ? messageKey : uuid.v4() 
		this._addMsgListener()
	},
	destroyed() {
		this._removeMsgListener()
	},
	computed: {
		uploadHeaders() {
			return {
				'Authorization': this.$store.state.system.user?.accessToken || null
			}
		}
	},
	methods: {
		openRouter(path) {
			const fullUrl = this.$router.resolve({
				path
			}).href
			window.open(fullUrl, '_blank')
		},
		pushPath(path) {
			this.$router.push(path);
		},
		replacePath(path) {
			this.$router.replace(path);
		},
		// Dialog or Drawer
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		// Pagination
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
		},
		// Table
		handleSelectionChange(val) {
			console.log('Overwrite Todo: handleSelectionChange', val)
		},
		sortChanged({
			column,
			prop,
			order
		}) {
			console.log('Overwrite Todo: sortChanged', column, prop, order)
		},
		// Upload
		uploadOnProgress(event, file, fileList) {
			console.log('Overwrite Todo: uploadOnProgress', event, file, fileList)
		},
		uploadOnSuccess(response, file, fileList) {
			console.log('Overwrite Todo: uploadOnSuccess', response, file, fileList)
		},
		uploadOnError(err, file, fileList) {
			console.log('Overwrite Todo: uploadOnError', err, file, fileList)
		},
		// 
		// Mssage
		//
		// 发送消息
		sendMessage(name, data) {
			// 子向父
			window.parent?.postMessage({ name: name + this.messageKey, data }, '/')
			// 窗口间消息传递
			for (let i = 0; i < (window.parent?.frames.length || 0); i++) {
				window.parent?.frames[i].postMessage({ name: name + this.messageKey, data }, '/')
			}
		},
		// 注册消息
		addMsgHandler(name, handler) {
			try {
				this.msgHandlers[name+this.messageKey] = handler
			} catch (e) {console.error(e)}
			
		},
		_handleMsg(event) {
			const {
				data:eventData,
				type
			} = event
			try {
				if (type === 'message') {
					const {name, data} = eventData
					if (name) {
						const handler = this.msgHandlers[name]
						handler && handler(data)
					}
				}
			} catch (e) {}
		},
		_addMsgListener() {
			window.addEventListener("message", this._handleMsg);
		},
		_removeMsgListener() {
			window.removeEventListener("message", this._handleMsg);
		}
	}
}